import React from "react";
import WhatsApp from "./whatsapp";
import Link from "next/link";
import {
  InstagramLogo,
  WhatsappLogo,
  XLogo,
  TwitterLogo,
} from "@phosphor-icons/react/dist/ssr";

const Footer: React.FC = () => {
  return (
    // <footer className="text-center lg:text-left">
    <footer className="w-full flex flex-col justify-center items-center border-t border-gray-200">
      {/* <!-- Main container div: holds the entire content of the footer, including four sections (TW Elements, Products, Useful links, and Contact), with responsive styling and appropriate padding/margins. --> */}
      <div className="mx-6 text-center">
        <div className="grid-1 grid gap-8 sm:grid-cols-1 lg:grid-cols-4 pt-10">
          {/* <!-- Products section --> */}
          <div className="text-neutral-500 text-xs flex flex-col justify-center h-full">
            <h6 className="mb-4 flex justify-center font-semibold uppercase">
                  Popular Builders
            </h6>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-my-home">My Home</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-aparna">Aparna</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-rajapushpa">Rajapushpa</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-prestige">Prestige</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-asbl">ASBL</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-omsree">OMSREE</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-ramky">Ramky</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-myscape">Myscape</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/list/hyderabad/builder-vasavi">Vasavi</a>
            </p>
          </div>
          {/* <!-- Useful links section --> */}
          <div className="text-neutral-500 text-xs">
            <h6 className="mb-4 flex justify-center font-semibold uppercase md:justify-start">
              Projects in popular locations
            </h6>
            <p className="mb-4 hover:underline">
              <a href="/locality/12685/v2">Ameenpur</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/locality/7009/v2">Kukatpally</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/locality/11599/v2">Gandipet</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/locality/6963/v2">Dundigal</a>
            </p>
            {/* <p className="mb-4 hover:underline">
              <a href="/locality/18532/v2">Hanamkonda</a>
            </p> */}
            <p className="mb-4 hover:underline">
              <a href="/locality/11803/v2">Mankhal</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/locality/11616/v2">Puppalguda</a>
            </p>
            <p className="mb-4 hover:underline">
              <a href="/locality/2971/v2">Khammam</a>
            </p>
          </div>
          <div className="flex flex-col">
            <div className="text-neutral-500">
              <p className="mb-4 hover:underline text-md font-semibold text-red-500">
                <Link href="/builder">Sales intelligence for builders</Link>
              </p>
            </div>
            <Link
              href="/landing/nri"
              className="text-md text-secondary font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              NRI
            </Link>
            <Link
              href="/calculators/apartment-buying-calculator"
              className="text-md opacity-50 font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              Calculator
            </Link>
            <Link
              href="/policy/tos"
              className="text-md opacity-50 font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              Terms of service
            </Link>
            <Link
              href="/policy/cancellation-refund"
              className="text-md opacity-50 font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              Cancellation and refund policy
            </Link>
            <Link
              href="/policy/contact"
              className="text-md opacity-50 font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              About
            </Link>
            <Link
              href="/policy/privacy"
              className="text-md opacity-50 font-medium hover:underline underline-offset-4"
              prefetch={false}
            >
              Privacy
            </Link>
            <div>
              TS RERA: A02500003878
            </div>
            <div className="flex flex-row gap-2 mt-2">
              <Link href="https://x.com/archerabi">
                <TwitterLogo size={32} weight={"fill"} />
              </Link>
              <Link href="https://x.com/archerabi">
                <XLogo size={32} weight={"fill"} />
              </Link>
              <Link href="https://instagram.com/bhumibossdotcom">
                <InstagramLogo size={32} weight={"fill"} />
              </Link>
              <Link href="https://wa.me/917386796083">
                <WhatsappLogo size={32} weight={"fill"} />
              </Link>
            </div>
          </div>
          <WhatsApp />
        </div>
      </div>
      {/* <!--Copyright section--> */}
      {/* <div className="bg-neutral-200 p-6 text-center dark:bg-neutral-700">
        <span>© 2024 Copyright:</span>
        <a
          className="font-semibold text-neutral-600 dark:text-neutral-400"
          href="https://tw-elements.com/"
        >
          LittleSugar Software Pvt. Ltd.
        </a>
      </div> */}
      <div className="flex flex-col items-center">
        <p className="text-center text-sm text-gray-500">
          © 2024 BhumiBoss. All rights reserved.
        </p>
        <p className="text-center text-sm text-gray-500">
          LittleSugar Software Pvt. Ltd.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
